import * as React from 'react';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function LogoMaker() {
  const [selectedValue, setSelectedValue] = React.useState('a');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const renderStyle1 = () => {
    return <>
      <Typography variant="h6" display="inline" sx={{paddingTop: '10px'}}>
        iCh
      </Typography>

      <Radio
        sx={{padding: '0px'}}
        checked={selectedValue === 'a'}
        onChange={handleChange}
        value="a"
        name="radio-buttons"
        inputProps={{'aria-label': 'A'}}
      />
      <Radio
        sx={{padding: '0px'}}
        checked={selectedValue === 'b'}
        onChange={handleChange}
        value="b"
        name="radio-buttons"
        inputProps={{'aria-label': 'B'}}
      />

      <Typography variant="h6" display="inline">
        se
      </Typography>
    </>
  }

  const renderStyle2 = () => {
    return <>
      <br/>
      ｉＣｈｏｏｓｅ
      <br/>
      ⒤⒞⒣⒪⒪⒮⒠
      <br/>
      ｉＣｈ⒪⒪ｓｅ
      <br/>
      ｉＣｈⓞ🅞ｓｅ
      <br/>
      ⓞ | 🅞
      <br/>


    </>
  }
  return (
    <Box sx={{textAlign: 'center', verticalAlign: 'middle', pt: 10}}>
      {/*<Typography variant="button" display="inline" gutterBottom>*/}
      {/*    button text*/}
      {/*</Typography>*/}
      {renderStyle1()}
      <br/>
      {renderStyle2()}
      <br/>
      <a href={'https://tools.picsart.com/text/font-generator/cool/'}> Use this like to generate fonts</a>

    </Box>
  );
}
